'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const RssIcon: TSVGIcon = createIcon({
  displayName: 'RssIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 5a1 1 0 0 1 1-1c8.284 0 15 6.716 15 15a1 1 0 1 1-2 0c0-7.18-5.82-13-13-13a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1Zm2.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'
    />
  ),
});
